import { defineComponent, computed, openBlock, createElementBlock, toDisplayString, createCommentVNode, createElementVNode, createVNode, unref, mergeProps, withCtx, createBlock, createTextVNode, Fragment, renderList } from "vue";
import { CdrLink, CdrBanner, IconErrorFill } from "@rei/cedar";
import GenericSelectorTile from "../../GenericSelectorTile/GenericSelectorTile.mjs";
import GenericErrorText from "../../GenericErrorText/GenericErrorText.mjs";
import BuyBoxChangeShippingForm from "../BuyBoxChangeShippingForm/BuyBoxChangeShippingForm.mjs";
const _hoisted_1 = {
  class: "fulfillment-tiles",
  "data-ui": "product-shipping-options"
};
const _hoisted_2 = {
  key: 0,
  class: "fulfillment-tiles__select-message",
  "data-ui": "fulfillment-tile-select-message"
};
const _hoisted_3 = {
  class: "fulfillment-tiles__button-wrapper"
};
const _hoisted_4 = {
  class: "fulfillment-tiles__expanded-info"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  class: "fulfillment-tiles__expanded-info--bike"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxFulfillmentTiles",
  props: {
    editorProps: {
      default: () => ({
        editorIsOpen: false,
        geolocationError: false,
        initialZip: "",
        invalid: false
      })
    },
    isLoading: {
      type: Boolean
    },
    selectedShipping: {},
    tileContent: {
      default: () => ({
        errors: {
          message: "",
          pickupError: false,
          shipError: false,
          showError: false,
          showNetworkErrorMessage: false
        },
        isBike: false,
        message: "",
        pickupTileContent: {
          method: ""
        },
        shipTileContent: {
          method: ""
        },
        shippingContextMessages: []
      })
    },
    isSizeSelected: {
      type: Boolean,
      default: false
    },
    isColorSelected: {
      type: Boolean,
      default: false
    },
    sizeLabel: {},
    colorLabel: {}
  },
  emits: ["metricsClick", "registerRef", "shipUpdate", "storeFinderClick", "updateAddress", "updateEditorOpen", "updateGeolocation", "clearGeolocationError", "shippingInfoClick", "oversizeInfoClick", "preorderBannerClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const selectSizeOrColorMessage = computed(() => {
      let unselectedOption;
      if (!props.isSizeSelected && props.isColorSelected) {
        unselectedOption = props.sizeLabel.toLowerCase();
      } else if (props.isSizeSelected && !props.isColorSelected) {
        unselectedOption = props.colorLabel.toLowerCase();
      } else {
        unselectedOption = `${props.sizeLabel.toLowerCase()} and/or ${props.colorLabel.toLowerCase()}`;
      }
      return `Select ${unselectedOption} for delivery dates`;
    });
    const handleShipClick = () => {
      emit("shipUpdate", "SHIP");
      emit("metricsClick", {
        linkName: "ship to address"
      });
    };
    const handleStorePickupClick = () => {
      emit("shipUpdate", "PICKUP");
      emit("metricsClick", {
        linkName: "pick up in store"
      });
    };
    const handleZipChangeClick = () => {
      emit("updateEditorOpen", true);
      emit("metricsClick", {
        linkName: "change zip code"
      });
    };
    const handleShippingEvent = (event) => {
      emit(event);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [!_ctx.isSizeSelected || !_ctx.isColorSelected ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(selectSizeOrColorMessage.value), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_3, [createVNode(unref(GenericSelectorTile), mergeProps({
        ref: "pickupTile"
      }, _ctx.tileContent.pickupTileContent, {
        selected: _ctx.selectedShipping === "PICKUP",
        "is-loading": _ctx.isLoading,
        "aria-describedby": _ctx.tileContent.errors.pickupError ? "fulfillment-error-text" : null,
        "data-ui": "product-shipping-option-pickUp",
        onFulfillmentClick: handleStorePickupClick,
        onRegisterRef: _cache[1] || (_cache[1] = (ref) => _ctx.$emit("registerRef", {
          type: "pickupTile",
          value: ref
        }))
      }), {
        changeLink: withCtx(() => [!_ctx.tileContent.pickupTileContent.notOffered ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          "data-ui": "product-pick-up-in-store-link",
          tag: "button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("storeFinderClick"))
        }, {
          default: withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" Edit store ")])),
          _: 1,
          __: [7]
        })) : createCommentVNode("", true)]),
        _: 1
      }, 16, ["selected", "is-loading", "aria-describedby"]), createVNode(unref(GenericSelectorTile), mergeProps({
        ref: "shipTile"
      }, _ctx.tileContent.shipTileContent, {
        class: "fulfillment-tiles__ship-tile",
        selected: _ctx.selectedShipping === "SHIP",
        "is-loading": _ctx.isLoading,
        "aria-describedby": _ctx.tileContent.errors.shipError ? "fulfillment-error-text" : null,
        "data-ui": "product-shipping-option-shipToAddress",
        onFulfillmentClick: handleShipClick,
        onRegisterRef: _cache[2] || (_cache[2] = (ref) => _ctx.$emit("registerRef", {
          type: "shipTile",
          value: ref
        }))
      }), {
        changeLink: withCtx(() => [!_ctx.tileContent.shipTileContent.notOffered ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          "data-ui": "fulfillment-tile-change-address",
          tag: "button",
          type: "button",
          onClick: handleZipChangeClick
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tileContent.shipTileContent.location ? "Edit ZIP code" : "Add ZIP code"), 1)]),
          _: 1
        })) : createCommentVNode("", true)]),
        _: 1
      }, 16, ["selected", "is-loading", "aria-describedby"])]), createElementVNode("div", _hoisted_4, [_ctx.editorProps.editorIsOpen ? (openBlock(), createBlock(unref(BuyBoxChangeShippingForm), mergeProps({
        key: 0
      }, _ctx.editorProps, {
        onClose: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("updateEditorOpen", false)),
        onUpdateAddress: _cache[4] || (_cache[4] = (data) => _ctx.$emit("updateAddress", data)),
        onUpdateGeolocation: _cache[5] || (_cache[5] = (data) => _ctx.$emit("updateGeolocation", data)),
        onClearGeolocationError: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("clearGeolocationError"))
      }), null, 16)) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.tileContent.shippingContextMessages, (shippingContextMessage) => {
        return openBlock(), createElementBlock(Fragment, null, [shippingContextMessage.show ? (openBlock(), createElementBlock("div", {
          key: shippingContextMessage.message,
          class: "fulfillment-tiles__shipping-context-message"
        }, [createElementVNode("span", {
          innerHTML: shippingContextMessage.message
        }, null, 8, _hoisted_5), shippingContextMessage.linkEvent ? (openBlock(), createBlock(unref(CdrLink), {
          key: 0,
          "data-ui": "product-pick-up-in-store-link",
          tag: "button",
          type: "button",
          onClick: ($event) => handleShippingEvent(shippingContextMessage.linkEvent)
        }, {
          default: withCtx(() => _cache[8] || (_cache[8] = [createTextVNode(" Details ")])),
          _: 2,
          __: [8]
        }, 1032, ["onClick"])) : createCommentVNode("", true)])) : createCommentVNode("", true)], 64);
      }), 256)), _ctx.tileContent.isBike && _ctx.selectedShipping === "PICKUP" ? (openBlock(), createElementBlock("div", _hoisted_6, _cache[9] || (_cache[9] = [createElementVNode("strong", null, "Heads up!", -1), createTextVNode(" Bikes usually take 1-2 additional days to assemble but can take longer during busy periods. We'll email you when yours is ready. ")]))) : createCommentVNode("", true)], 64)), _ctx.tileContent.errors.showError ? (openBlock(), createBlock(unref(GenericErrorText), {
        key: 2,
        id: "fulfillment-error-text",
        class: "fulfillment-tiles__error-text"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.tileContent.errors.message), 1)]),
        _: 1
      })) : createCommentVNode("", true), _ctx.tileContent.errors.showNetworkErrorMessage ? (openBlock(), createBlock(unref(CdrBanner), {
        key: 3,
        type: "error"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconErrorFill))]),
        default: withCtx(() => [_cache[10] || (_cache[10] = createElementVNode("div", {
          class: "fulfillment-tiles__error-banner"
        }, [createElementVNode("span", {
          class: "fulfillment-tiles__error-banner--emphasized"
        }, " Store inventory info not available. "), createTextVNode(" Please refresh or try again later. ")], -1))]),
        _: 1,
        __: [10]
      })) : createCommentVNode("", true)])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxFulfillmentTiles2.mjs.map
